<template>
  <div class="select-bridge">
    <div class="select-mask"></div>
    <div class="bridge-list">
      <div class="bridge-info" v-for="(bridge, index) in dataList" :key="index" :title="bridge.name">
        <div class="bridge-img-warp" @click="doTo(bridge.indexUrl)">
          <div class="bridge-img" :class="bridge.className"></div>
          <div class="bdg-mask"></div>
        </div>
        <div class="bridge-name">{{ bridge.name }}</div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      bridgeList: "getBridgeList",
      isAdmin: "getIsAdmin",
    }),
  },
  data() {
    return {
      authList: [
        {
          basePath: "admin",
          name: "用户信息",
          className: "bridge-user",
          indexUrl: "/admin/userControl",
        },
        {
          basePath: "admin",
          name: "连接状态",
          className: "bridge-socket-comm",
          indexUrl: "/admin/socketCommStatusControl",
        },
        {
          basePath: "admin",
          name: "数据历史访问申请",
          className: "bridge-history-access",
          indexUrl: "/admin/historyAccessControl",
        },
      ],
      adminList: [
        {
          basePath: "admin",
          name: "数据历史",
          className: "bridge-history",
          indexUrl: "/admin/dataHistory",
        },
        {
          basePath: "admin",
          name: "数据历史访问审批",
          className: "bridge-history-access",
          indexUrl: "/admin/historyAccessControl",
        },
        {
          basePath: "admin",
          name: "历史场景管理",
          className: "bridge-history-scenario",
          indexUrl: "/admin/historyScenarioControl",
        },
        {
          basePath: "admin",
          name: "报警记录",
          className: "bridge-error-record",
          indexUrl: "/admin/errorRecord?bridgeId=admin",
        },
        // {
        //   basePath: 'admin',
        //   name: '上传记录',
        //   className: 'bridge-socket',
        //   indexUrl: '/admin/socket',
        // },
      ],
      dataList: [],
      timer: null,
    };
  },
  created() {
    let controlList = [];
    if (this.isAdmin) {
      for (let authItem of this.authList) {
        let sameIndexItem = this.adminList.filter((item) => {
          return authItem.indexUrl === item.indexUrl;
        })[0];

        if (sameIndexItem) {
          continue;
        }

        controlList.push(authItem);
      }

      controlList = controlList.concat(this.adminList);
    } else {
      controlList = this.authList;
    }

    //this.dataList = this.bridgeList.concat(this.authList, this.isAdmin ? this.adminList : []);
    this.dataList = this.bridgeList.concat(controlList);

    this.dataList = this.dataList.filter(function (element, index) {
      return element.className && element.className !== "";
    });
  },
  mounted() {
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    checkAuth() {
      this.$http.get("/auth/LoginInfo").then((res) => { });
    },
    /**
     * 跳转
     * @param {String} url # 大桥首页URL
     */
    doTo(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style scoped lang="scss">
.select-bridge {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background: url("./../assets/image/select-bg.png") center no-repeat;
  background-size: cover;
  justify-content: center;

  .bridge-info {
    width: 320px;
    height: 240px;
    border-radius: 6px;
    align-items: center;

    .bridge-dashashui {
      background: url("../assets/image/dasha/dasha-mini.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-qingshui {
      background: url("../assets/image/qingshui/qingshui.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-history {
      background: url("../assets/image/history.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-user {
      background: url("../assets/image/user.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-socket {
      background: url("../assets/image/socket.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-socket-comm {
      background: url("../assets/image/socketComm.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-history-scenario {
      background: url("../assets/image/historyScenario.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-history-access {
      background: url("../assets/image/historyAccess.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-error-record {
      background: url("../assets/image/errorRecord.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-jiajiang {
      background: url("../assets/image/jiajiang/jiajiang.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-nanjinsiqiao {
      background: url("../assets/image/nansi/nansi.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-xijiangdaqiao {
      background: url("../assets/image/xijiangdaqiao.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-nanshadaqiao {
      background: url("../assets/image/nizhou/nizhou_mini.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-sutong {
      background: url("../assets/image/sutong/sutong.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-qipanzhou {
      background: url("../assets/image/qipanzhou/qipanzhou.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-hangzhouwan {
      background: url("../assets/image/hangzhouwan/hangzhouwan.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-xihoumen {
      background: url("../assets/image/xihoumen/xihoumen.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-xihoumen-sensor {
      background: url("../assets/image/xihoumen/xihoumen.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-xihoumen-fresh-air {
      background: url("../assets/image/xihoumen/xihoumen.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-balinghe-sensor {
      background: url("../assets/image/balinghe/balinghe.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-liede {
      background: url("../assets/image/liede/liede.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-jinshajiang {
      background: url("../assets/image/jinshajiang/jinshajiang.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-guizhouInspectGroup {
      background: url("../assets/image/malinghe/malinghe.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-aipuruiInspectGroup {
      background: url("../assets/image/balinghe/balinghe.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-jiashao {
      background: url("../assets/image/jiashao/jiashao.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-aizhai {
      background: url("../assets/image/aizhai/aizhai.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-beipanjiang {
      background: url("../assets/image/beipanjiang/beipanjiang.jpg") center no-repeat;
      background-size: cover;
    }


    .bridge-yichang {
      background: url("../assets/image/qingshui/qingshui.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-jiangshun {
      background: url("../assets/image/jiangshun/jiangshun.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-yueqingwan {
      background: url("../assets/image/yueqingwan/yueqingwan.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-averageAnalysis {
      background: url("../assets/image/qingshui/qingshui.jpg") center no-repeat;
      background-size: cover;
    }

    .bridge-name {
      line-height: 70px;
      color: #fff;
      text-align: center;
      font-size: 26px;
    }

    .bdg-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      transition: opacity 0.3s, transform 0.3s;
      background-color: rgba(0, 0, 0, 0.25);
    }

    .bridge-img {
      width: 100%;
      height: 100%;
      overflow: hidden;
      transition: transform 0.3s;
    }

    .bridge-img-warp:hover {
      .bdg-mask {
        opacity: 0;
        transform: scale(1.15);
      }

      .bridge-img {
        transform: scale(1.15);
      }
    }

    .bridge-img-warp {
      width: 100%;
      height: 160px;
      border-radius: 6px;
      position: relative;
      cursor: pointer;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .select-mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
  }

  .bridge-list {
    position: relative;
    z-index: 2;
    height: 100%;
    width: 1400px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-around;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden auto;
  }

  .bridge-list::-webkit-scrollbar {
    width: 0 !important;
  }

  .bridge-list {
    -ms-overflow-style: none;
  }

  .bridge-list {
    overflow: -moz-scrollbars-none;
  }
}
</style>
